import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/header";
import Navbar from "../../components/navbar";

import CardLeftRight from "../../components/cardleftright";

import { useLocation } from "react-router-dom";

import { DataLists } from "../../dataLists/DataLists";
import { dataListsType } from "../../components/featured-posts";
import AdPage from "../../components/AdPage";
import Currency from "../../components/currency";

const DetailsPage: React.FC = () => {
  // const { state } = useLocation();
  // const dataProps = state || {};
  const [isShow, setIsShow] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let idItem = queryParams.get("id");

  const [currentItem, setCurrentItem] = useState<dataListsType | null>(null);

  const [recommended, setRecommended] = useState<dataListsType[]>([]);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const getRecommended = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 5);
    setRecommended(data);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getIdBodyHtml = () => {
    const datas = [...DataLists];
    if (!idItem) return null;
    const idBodyHtml = datas.find((item) => item.id.toString() === idItem);
    setCurrentItem(idBodyHtml || null);
  };

  useEffect(() => {
    getRecommended();
  }, []);
  useEffect(() => {
    getIdBodyHtml();
  }, [getIdBodyHtml, idItem]);

  useEffect(() => {
    if (currentItem) {
      // 更新頁面標題
      const pageTitle = `${currentItem.title} | ${currentItem.nation} ${currentItem.category} | Explore Asia`;
      document.title = pageTitle;

      // 更新meta description
      const description = `Discover ${currentItem.title} in ${
        currentItem.nation
      }. ${
        currentItem.description || ""
      } Explore Asia brings you comprehensive guides about ${currentItem.category.toLowerCase()} in ${
        currentItem.nation
      }.`;

      // 更新keywords
      const keywords = `${currentItem.nation}, ${currentItem.category}, ${
        currentItem.title
      }, Asia Travel, ${currentItem.tags?.join(", ") || ""}`;

      // 更新所有meta標籤
      const metaTags = [
        { name: "description", content: description },
        { name: "keywords", content: keywords },
        { property: "og:title", content: pageTitle },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: window.location.href },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: pageTitle },
        { name: "twitter:description", content: description },
      ];

      // 如果有圖片，添加og:image和twitter:image
      if (currentItem.images) {
        const imageUrl = Array.isArray(currentItem.images)
          ? currentItem.images[0]
          : currentItem.images;
        metaTags.push(
          { property: "og:image", content: imageUrl },
          { name: "twitter:image", content: imageUrl }
        );
      }

      // 更新或創建meta標籤
      metaTags.forEach(({ name, property, content }) => {
        let meta = document.querySelector(
          property ? `meta[property="${property}"]` : `meta[name="${name}"]`
        );

        if (!meta) {
          meta = document.createElement("meta");
          if (property) {
            meta.setAttribute("property", property);
          } else {
            // 确保name不为undefined后再设置属性
            if (name) {
              meta.setAttribute("name", name);
            }
          }
          document.head.appendChild(meta);
        }

        meta.setAttribute("content", content);
      });
    }

    // 組件卸載時清理meta標籤
    return () => {
      document.title = process.env.REACT_APP_SITE_TITLE || "Explore Asia";

      const defaultDescription =
        process.env.REACT_APP_DESCRIPTION ||
        "Explore Asia - Your Guide to Asian Travel and Culture";

      const metaSelectors = [
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[property="og:type"]',
        'meta[property="og:url"]',
        'meta[property="og:image"]',
        'meta[name="twitter:card"]',
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]',
        'meta[name="twitter:image"]',
      ];

      metaSelectors.forEach((selector) => {
        const meta = document.querySelector(selector);
        if (meta) {
          if (selector === 'meta[name="description"]') {
            meta.setAttribute("content", defaultDescription);
          } else {
            meta.remove();
          }
        }
      });
    };
  }, [currentItem]); // 當文章數據改變時重新執行

  useEffect(() => {
    const handleResize = (event: MessageEvent) => {
      if (event.data?.iframeHeight && iframeRef.current) {
        iframeRef.current.style.height = `${event.data.iframeHeight}px`;
      }
    };
    window.addEventListener("message", handleResize);
    return () => {
      window.removeEventListener("message", handleResize);
    };
  }, []);

  return (
    <>
      <Header />
      <Navbar />

      <AdPage />

      {/* 基础 Helmet */}
      <Helmet>
        <title>
          {currentItem
            ? `${currentItem.title} | ${currentItem.nation} ${currentItem.category} | Explore Asia`
            : "Explore Asia"}
        </title>
        <meta
          name="description"
          content={
            currentItem
              ? `Discover ${currentItem.title} in ${currentItem.nation}. ${
                  currentItem.description || ""
                } Explore Asia brings you comprehensive guides about ${currentItem.category.toLowerCase()} in ${
                  currentItem.nation
                }.`
              : ""
          }
        />
      </Helmet>

      {/* 条件渲染的 Helmet */}
      {currentItem && (
        <Helmet>
          <meta
            name="keywords"
            content={`${currentItem.nation}, ${currentItem.category}, ${
              currentItem.title
            }, Asia Travel, ${currentItem.tags?.join(", ") || ""}`}
          />
          <meta
            property="og:title"
            content={`${currentItem.title} | ${currentItem.nation} ${currentItem.category} | Explore Asia`}
          />
          <meta
            property="og:description"
            content={`Discover ${currentItem.title} in ${currentItem.nation}. ${
              currentItem.description || ""
            }`}
          />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={window.location.href} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      )}

      {/* 图片相关的 Helmet */}
      {currentItem && currentItem.images && (
        <Helmet>
          <meta
            property="og:image"
            content={
              Array.isArray(currentItem.images)
                ? currentItem.images[0]
                : currentItem.images
            }
          />
        </Helmet>
      )}

      <div className="w-full flex justify-center">
        <iframe
          title="Details Page Content"
          className="w-full"
          style={{ height: "0px", transition: "height 0.2s" }}
          ref={iframeRef}
          srcDoc={`
            <!DOCTYPE html>
            <html lang="en">
              <head>
                <style>
                  body { overflow: hidden; margin: 0; }
                  *::-webkit-scrollbar { display: none; }
                   ${currentItem?.css ? currentItem.css : ""}
                  .loading {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100px;
                    width: 100%;
                    background-color: #f6f7f8;
                    color: #5e5e5e;
                    font-size: 1.5rem;
                    font-weight: bold;
                  }
                </style>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Document</title>
              </head>
              <body>
                ${
                  currentItem?.body
                    ? currentItem.body
                    : `<div 
                        style="
                          font-size: 1.5rem; 
                          font-weight: bold; 
                          color: #5e5e5e; 
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 100px;
                          width: 100%;
                      ">Loading...</div>`
                }
                <script>
                  const resizeObserver = new ResizeObserver(() => {
                    const height = document.body.scrollHeight;
                    window.parent.postMessage({ iframeHeight: height }, '*');
                  });
                  resizeObserver.observe(document.body);
                  window.addEventListener('resize', () => {
                    const height = document.body.scrollHeight;
                    window.parent.postMessage({ iframeHeight: height }, '*');
                  });
                </script>
              </body>
            </html>
          `}
        ></iframe>
      </div>

      <div className="w-full flex flex-col justify-center items-center mb-6">
        <div className="w-full max-w-[968px] px-10 bg-yellow-0">
          <span className="p-0">
            Need to know the exchange rate?{" "}
            <b
              className="text-[#5b68d3] cursor-pointer"
              onClick={() => setIsShow(!isShow)}
            >
              Click here.
            </b>
          </span>
        </div>
        {isShow && (
          <>
            <div className="w-full max-w-[968px] px-1 flex justify-center bg-red-0">
              <Currency />
            </div>
          </>
        )}
      </div>

      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] mt-5 mb-10">
          <div className="w-full mb-16 px-8">
            <div className="mb-8 border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-widest flex justify-between">
                <span>Recommended</span>
              </h5>
              <span className="block w-14 h-[3px] bg-black"></span>
            </div>
            <div className="w-full flex flex-col gap-y-10">
              <CardLeftRight props={recommended} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsPage;
